module.exports = __webpack_public_path__ + "static/media/guitar_wall.91c2e35f.jpg";